/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Alert, Box } from "@mui/material";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import TextInput from "src/components/input/TextInput";
import { LoadingButton } from "@mui/lab";
import { opcionesTipoIdentificacionPersonaNatural } from "src/utils/constantes";
import { useActualizarDatosPersonalesMutation } from "src/redux/api/usuariosApi";
import { toast } from "react-toastify";
import { useRefreshTokenMutation } from "src/redux/api/authApi";
import {
  useObtenerDepartamentosPorPaisQuery,
  useObtenerMunicipiosPorDepartamentoQuery,
  useObtenerPaisesQuery,
} from "src/redux/api/maestrosApi";
import CustomAutocomplete from "src/components/input/Autocomplete";
import {
  departamentosResponseToOpcionSelect,
  municipiosResponseToOpcionSelect,
  paisesResponseToOpcionSelect,
} from "src/redux/api/types/maestros";
import {
  IactualizacionDatosForm,
  esquemaDeValidacionActualizacionDatos,
  valoresInicialesActualizacionDatos,
} from "./utils";

const FormularioDatosPersonales = () => {
  const [actualizarDatos, {isLoading: actualizando}] = useActualizarDatosPersonalesMutation();
  const [refreshToken] = useRefreshTokenMutation();
  const [valoresForm, setValoresForm] = useState<IactualizacionDatosForm>(
    valoresInicialesActualizacionDatos,
  );
  const [paisSeleccionado, setPaisSeleccionado] = useState<string>("");
  const [departamentoSeleccionado, setDepartamentoSeleccionado] =
    useState<string>("");
  const { data: paisesResp } = useObtenerPaisesQuery();
  const { data: departamentosResp } = useObtenerDepartamentosPorPaisQuery(
    paisSeleccionado,
    { skip: paisSeleccionado === "" },
  );
  const { data: municipiosResp } = useObtenerMunicipiosPorDepartamentoQuery(
    departamentoSeleccionado,
    { skip: departamentoSeleccionado === "" },
  );


  const handleRegistro = async (values: IactualizacionDatosForm) => {
    const valores = {
      ...values,
      municipioId: paisSeleccionado === "7eea27df-150b-4ba8-b948-65aaf95ce89e" ? values.municipioId : '',
    };
    actualizarDatos(valores)
      .unwrap()
      .then(() => {
        toast.success("Datos actualizados correctamente");
        refreshToken();
      });
  };

  return (
    <Box sx={{ paddingX: 20 }}>
      <Alert severity="warning" sx={{ textAlign: "left" }}>
        Para garantizar una correcta trazabilidad de los datos, es de vital
        importancia que tengas actualizados tus datos personales.
      </Alert>
      <br />
      <Formik
        enableReinitialize
        initialValues={valoresForm}
        validationSchema={esquemaDeValidacionActualizacionDatos}
        onSubmit={handleRegistro}
      >
        <Form autoComplete="off">
          <Box
            display="flex"
            sx={{
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 0, md: 2 },
            }}
          >
            <TextInput
              label="Tipo de identificación"
              name="tipoIdentificacion"
              type="select"
              opciones={opcionesTipoIdentificacionPersonaNatural}
              data-testid="select-id"
            />
            <TextInput
              label="Número de identificación"
              name="identificacion"
              type="text"
            />
          </Box>
          <Box
            display="flex"
            sx={{
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 0, md: 2 },
            }}
          >
            <TextInput label="Nombres" name="nombres" type="text" />
            <TextInput label="Apellidos" name="apellidos" type="text" />
          </Box>
          <br />
          <Alert severity="info" sx={{ textAlign: "left" }}>
            Si tienes un correo institucional, por favor actualiza tu correo
            principal con el correo institucional, y podrás iniciar sesión con
            la contraseña de portal.
            <br />
            Si no tienes o has perdido acceso a tu correo institucional, por
            favor actualiza tu correo principal con un correo personal y realiza
            el proceso de recuperación de contraseña.
          </Alert>
          <br />
          <Box
            display="flex"
            sx={{
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 0, md: 2 },
            }}
          >
            <TextInput
              label="Correo principal"
              name="correo"
              type="email"
              InputLabelProps={{ shrink: true }}
            />
            <TextInput
              label="Correo alternativo"
              name="correoAlterno"
              type="email"
              InputLabelProps={{ shrink: true }}
            />
          </Box>
          <Box
            display="flex"
            sx={{
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 0, md: 2 },
            }}
          >
            <CustomAutocomplete
              label="Pais"
              name="paisId"
              setValue={setPaisSeleccionado}
              type="autocomplete"
              opciones={
                paisesResp ? paisesResponseToOpcionSelect(paisesResp) : []
              }
            />
            {paisSeleccionado === "7eea27df-150b-4ba8-b948-65aaf95ce89e" && (
              <>
                <CustomAutocomplete
                  label="Departamento"
                  name="departamentoId"
                  type="autocomplete"
                  setValue={setDepartamentoSeleccionado}
                  opciones={
                    departamentosResp
                      ? departamentosResponseToOpcionSelect(departamentosResp)
                      : []
                  }
                />
                <CustomAutocomplete
                  label="Municipio"
                  name="municipioId"
                  type="autocomplete"
                  opciones={
                    municipiosResp
                      ? municipiosResponseToOpcionSelect(municipiosResp)
                      : []
                  }
                />
              </>
            )}
          </Box>
          <Box
            display="flex"
            sx={{
              flexDirection: { xs: "column", md: "row" },
              gap: { xs: 0, md: 2 },
            }}
          >
            <TextInput
              label="Dirección"
              name="direccionResidencia"
              type="text"
            />
            <TextInput label="Celular" name="celular" type="text" />
          </Box>

          <Box display="flex" justifyContent="end" gap={2} marginTop={2}>
            <LoadingButton
              variant="contained"
              color="primary"
              loading={actualizando}
              sx={{ color: "white" }}
              type="submit"
              data-testid="btn-resgistrarse"
            >
              Actualizar datos
            </LoadingButton>
          </Box>
        </Form>
      </Formik>
    </Box>
  );
};

export default FormularioDatosPersonales;
